export default "__VITE_ASSET__eca9d65c__"